<template>
    <main class="py-12">
        <div class="container">
            <article class="dp-article">
                <div class="space-y-4">
                    <h1 class="h1 title">
                        AGB
                    </h1>
                    <p><strong>AGB</strong></p>
                    <p><strong>ALLGEMEINE GESCHÄFTSBEDINGUNGEN DER SAUERLAND SPIELGERÄTE GMBH</strong></p>
                    <ul>
                        <li><strong>1 Allgemeines – Geltungsbereich</strong></li>
                    </ul>
                    <p>
                        (1) Unsere Verkaufsbedingungen gelten ausschließlich; entgegenstehende oder von unseren
                        Verkaufsbedingungen abweichende Bedingungen des Kunden erkennen wir nicht an, es sei denn, wir
                        hätten ausdrücklich schriftlich ihrer Geltung zugestimmt. Unsere Verkaufsbedingungen gelten auch
                        dann, wenn wir in Kenntnis entgegenstehender oder von unseren Verkaufsbedingungen abweichender
                        Bedingungen des Kunden die Lieferung an den Kunden vorbehaltlos ausführen.
                    </p>
                    <p>
                        (2) Alle Vereinbarungen, die zwischen uns und dem Kunden zwecks Ausführung des Vertrages
                        getroffen werden, sind in dem jeweiligen Kaufvertrag einschließlich dieser Verkaufsbedingungen
                        schriftlich niedergelegt. § 305b BGB bleibt hiervon unberührt.
                    </p>
                    <p>
                        (3) Unsere Verkaufsbedingungen gelten nur gegenüber Unternehmern, juristischen Personen des
                        öffentlichen Rechts oder öffentlich-rechtlichen Sondervermögen i.S.v. § 310 Abs. 1 BGB.
                    </p>
                    <p>
                        (4) Schriftlichkeit in Sinne dieser Verkaufsbedingungen schließt Schrift- und Textform (z.B.
                        Brief, E-Mail, Telefax) ein.
                    </p>
                    <ul>
                        <li><strong>2 Angebot – Angebotsunterlagen</strong></li>
                    </ul>
                    <p>
                        (1) Unsere Angebote sind freibleibend und unverbindlich, sofern sie nicht ausdrücklich als
                        verbindlich gekennzeichnet sind oder eine bestimmte Annahmefrist enthalten.
                    </p>
                    <p>
                        (2) An Abbildungen, Zeichnungen, Kalkulationen und sonstigen Unterlagen behalten wir uns
                        Eigentums- und Urheberrechte vor. Dies gilt auch für solche schriftlichen Unterlagen, die als
                        „vertraulich“ bezeichnet sind. Vor ihrer Weitergabe an Dritte bedarf der Kunde unserer
                        ausdrücklichen schriftlichen Zustimmung.
                    </p>
                    <p>
                        (3) Wir behalten uns vor, Änderungen an der Kaufsache vorzunehmen, soweit diese Änderungen zur
                        Einhaltung der Sicherheitsvorgaben aus den Europäischen Normen EN 1176, EN 1177 und/oder EN 71
                        erforderlich sind.
                    </p>
                    <ul>
                        <li><strong>3 Preise – Zahlung – Abtretung - Bonitätsprüfung</strong></li>
                    </ul>
                    <p>
                        (1) Sofern sich aus der Auftragsbestätigung nichts anderes ergibt, gelten unsere Preise „ab
                        Werk“.
                    </p>
                    <p>
                        (2) Die gesetzliche Mehrwertsteuer ist nicht in unseren Preisen eingeschlossen; sie wird in
                        gesetzlicher Höhe am Tag der Rechnungsstellung in der Rechnung gesondert ausgewiesen.
                    </p>
                    <p>(3) Der Abzug von Skonto bedarf besonderer schriftlicher Vereinbarung.</p>
                    <p>
                        (4) Sofern sich aus der Auftragsbestätigung nichts anderes ergibt, ist der Kaufpreis entweder
                        per
                        Vorkasse innerhalb von 14 Tagen nach Erhalt der Auftragsbestätigung oder per Rechnung innerhalb
                        von 14 Tagen nach Rechnungsdatum der Rechnung zur Zahlung fällig. Es gelten die gesetzlichen
                        Regeln betreffend die Folgen des Zahlungsverzugs.
                    </p>
                    <p>
                        (5) Die uns gegenüber dem Kunden zustehende Forderung auf Bezahlung des Kaufpreises wird im Wege
                        des Factorings an die abcfinance GmbH, Kamekestraße 2-8, D-50672 Köln, eintragen beim
                        Amtsgericht Köln unter HRB 7873, abgetreten. Die Bezahlung des Kaufpreises erfolgt per
                        Überweisung auf das im Angebot&nbsp;bzw.&nbsp;in der Auftragsbestätigung angegebene Konto der
                        abcfinance GmbH oder per Übersendung eines Schecks an die abcfinance GmbH, wobei Schecks erst
                        nach Einlösung als Zahlung gelten.
                    </p>
                    <p>
                        (6) Wir sind berechtigt, noch ausstehende Lieferungen oder Leistungen nur gegen Vorauszahlung
                        auszuführen oder zu erbringen, wenn uns nach Abschluss des Vertrages Umstände bekannt werden,
                        welche die Kreditwürdigkeit des Kunden wesentlich zu mindern geeignet sind und durch welche die
                        Bezahlung unserer offenen Forderungen durch den Kunden aus dem jeweiligen Vertragsverhältnis
                        gefährdet wird, oder wenn der Kunde in Zahlungsverzug gerät.
                    </p>
                    <p>
                        (7) Aufrechnungsrechte stehen dem Kunden nur zu, wenn seine Gegenansprüche rechtskräftig
                        festgestellt, unbestritten oder von uns anerkannt sind oder wenn seine Aufrechnungsrechte auf
                        dem gleichen Vertragsverhältnis beruhen. Außerdem ist der Kunde zur Ausübung eines
                        Zurückbehaltungsrechts nur insoweit befugt, als sein Gegenanspruch auf dem gleichen
                        Vertragsverhältnis beruht.
                    </p>
                    <ul>
                        <li><strong>4 Lieferzeit</strong></li>
                    </ul>
                    <p>
                        (1) Die Einhaltung unserer Lieferverpflichtung setzt die rechtzeitige und ordnungsgemäße
                        Erfüllung der Verpflichtung des Kunden voraus. Die Einrede des nicht erfüllten Vertrages bleibt
                        vorbehalten.
                    </p>
                    <p>
                        (2) Kommt der Kunde in Annahmeverzug oder verletzt er schuldhaft sonstige Mitwirkungspflichten,
                        so sind wir berechtigt, den uns insoweit entstehenden Schaden, einschließlich etwaiger
                        Mehraufwendungen ersetzt zu verlangen. Weitergehende Ansprüche oder Rechte bleiben
                        vorbehalten.
                    </p>
                    <p>
                        (3) Sofern die Voraussetzungen des Annahmeverzugs vorliegen, geht die Gefahr eines zufälligen
                        Untergangs oder einer zufälligen Verschlechterung der Kaufsache in dem Zeitpunkt auf den Kunden
                        über, in dem dieser in Annahmeverzug geraten ist. Im Falle einer erforderlichen Abnahme geht die
                        Gefahr mit dem Ablauf einer angemessenen Frist nach Zugang der Fertigstellungsmitteilung auf den
                        Kunden über.
                    </p>
                    <ul>
                        <li><strong>5 Gefahrenübergang – Verpackung – Pflichten des Kunden</strong></li>
                    </ul>
                    <p>
                        (1) Sofern sich aus der Auftragsbestätigung – etwa bei Vereinbarung der Montage der Kaufsache –
                        nichts anderes ergibt, ist Lieferung „ab Werk“ vereinbart.
                    </p>
                    <p>(2) Für die Rücknahme von Verpackungen gelten gesonderte Vereinbarungen.</p>
                    <p>
                        (3) Soweit der Kunde an der Kaufsache bis zum Übergang des Eigentums an der Sache (siehe hierzu
                        §
                        8) ohne unsere schriftliche Zustimmung Änderungen vornimmt, ist er dazu verpflichtet, die
                        Sicherheitsvorgaben aus den Europäischen Normen EN 1176 und EN 1177 einzuhalten.
                    </p>
                    <ul>
                        <li><strong>6 Mängelhaftung</strong></li>
                    </ul>
                    <p>
                        (1) Kaufvertragliche Mängelansprüche des Kunden setzen voraus, dass dieser seinen nach §§ 377,
                        381 HGB geschuldeten Untersuchungs- und Rügeobliegenheiten ordnungsgemäß nachgekommen ist.
                    </p>
                    <p>
                        (2) Soweit ein Mangel der Kaufsache vorliegt, sind wir nach unserer Wahl zur Nacherfüllung in
                        Form einer Mängelbeseitigung oder zur Lieferung einer neuen mangelfreien Sache berechtigt. Im
                        Falle der Nacherfüllung sind wir verpflichtet, alle zum Zweck der Mangelbeseitigung
                        erforderlichen Aufwendungen, insbesondere Transport-, Wege-, Arbeits- und Materialkosten zu
                        tragen, soweit sich diese nicht dadurch erhöhen, dass die Kaufsache nach einem anderen Ort als
                        dem Erfüllungsort verbracht wurde es sei denn, die Verbringung entspricht dem bestimmungsgemäßen
                        Gebrauch der Ware.
                    </p>
                    <p>
                        &nbsp;(3) Die Verjährungsfrist im Fall eines Lieferregresses nach den §§ 445a, 445b BGB und
                        eines
                        Unternehmerrückgriffs nach den §§ 478, 479 BGB bleibt unberührt.
                    </p>
                    <ul>
                        <li><strong>7 Sonstige Haftung</strong></li>
                    </ul>
                    <p>
                        (1) Wir haften bei einer Verletzung von vertraglichen und außervertraglichen Pflichten nach den
                        gesetzlichen Vorschriften, soweit sich aus diesen Verkaufsbedingungen, einschließlich der
                        nachfolgenden Bestimmungen nichts anderes ergibt.
                    </p>
                    <p>
                        (2) Wir haften auf Schadensersatz - gleich aus welchem Rechtsgrund - im Rahmen der
                        Verschuldenshaftung bei Vorsatz und grober Fahrlässigkeit. Bei einfacher Fahrlässigkeit haften
                        wir vorbehaltlich eines milderen Haftungsmaßstabs nach gesetzlichen Vorschriften nur
                    </p>
                    <ul class="list-disc">
                        <li>für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit,</li>
                        <li>
                            für Schäden aus der nicht unerheblichen Verletzung einer wesentlichen Vertragspflicht
                            (Verpflichtung, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst
                            ermöglicht und auf deren Einhaltung der Vertragspartner regelmäßig vertraut und vertrauen
                            darf); in diesem Fall ist unsere Haftung jedoch auf den Ersatz des vorhersehbaren,
                            typischerweise eintretenden Schadens begrenzt. Mittelbare Schäden und Folgeschäden, wie z.
                            B. entgangener Gewinn, sind außerdem nur ersatzfähig, soweit solche Schäden bei
                            bestimmungsgemäßer Verwendung der Leistung typischerweise zu erwarten sind, insbesondere,
                            wenn sie Folge von Mängeln der Leistung sind.
                        </li>
                    </ul>
                    <p>
                        (3) Die sich aus § 7 (2) dieser Verkaufsbedingungen ergebenden Haftungsbeschränkungen gelten
                        auch, soweit der Kunde anstelle eines Anspruchs auf Ersatz des Schadens statt der Leistung, den
                        Ersatz nutzloser Aufwendungen verlangt.
                    </p>
                    <p>
                        (4) Die sich aus § 7 (2) und (3) dieser Verkaufsbedingungen ergebenden Haftungsbeschränkungen
                        gelten auch bei Pflichtverletzungen durch und zugunsten von Personen, deren Verschulden wir nach
                        gesetzlichen Vorschriften zu vertreten haben.
                    </p>
                    <p>
                        (5) Wegen einer Pflichtverletzung, die nicht in einem Mangel besteht, kann der Kunde nur
                        zurücktreten oder kündigen, wenn wir die Pflichtverletzung zu vertreten haben.
                    </p>
                    <p>
                        (6) Die Einschränkungen dieses § 7 gelten nicht für die unsere Haftung wegen vorsätzlichen
                        Verhaltens, für garantierte Beschaffenheitsmerkmale, für die Übernahme eines Beschaffungsrisikos
                        durch uns, wegen arglistigem Verschweigen eines Mangels, wegen der Übernahme eines
                        Beschaffungsrisikos, wegen Verletzung des Lebens, des Körpers oder der Gesundheit oder für
                        Ansprüche des Kunden nach dem Produkthaftungsgesetz. Unsere Angaben zu den Produkten sind nur
                        dann als Garantie oder Übernahme des Beschaffungsrisikos anzusehen, wenn sie ausdrücklich als
                        solche bezeichnet sind.
                    </p>
                    <ul>
                        <li><strong>8 Eigentumsvorbehaltssicherung</strong></li>
                    </ul>
                    <p>
                        (1) Wir behalten uns das Eigentum an unserer Leistung (nachfolgend „Vorbehaltsware“) bis zum
                        Eingang aller Zahlungen aus der Geschäftsverbindung mit den Kunden vor (gesicherte Forderung).
                        Bei vertragswidrigem Verhalten des Kunden, insbesondere bei Zahlungsverzug, sind wir berechtigt,
                        die Vorbehaltsware zurückzunehmen. In der Zurücknahme der Vorbehaltsware durch uns liegt kein
                        Rücktritt vom Vertrag. Wir sind nach Rücknahme der Vorbehaltsware zu deren Verwertung befugt,
                        der Verwertungserlös ist auf die Verbindlichkeiten des Kunden – abzüglich angemessener
                        Verwertungskosten – anzurechnen.
                    </p>
                    <p>
                        (2) Der Kunde ist verpflichtet, die Vorbehaltsware pfleglich zu behandeln. Es bleibt dem Kunden
                        überlassen, die Vorbehaltsware auf eigene Kosten gegen Feuer-, Wasser- und Diebstahlsschäden
                        ausreichend zum Neuwert zu versichern. Sofern Wartungs- und Inspektionsarbeiten erforderlich
                        sind, muss der Kunde diese auf eigene Kosten rechtzeitig durchführen.
                    </p>
                    <p>
                        (3) Bei Pfändungen oder sonstigen Eingriffen Dritter hat uns der Kunde unverzüglich schriftlich
                        zu benachrichtigen, damit wir Klage gemäß § 771 ZPO erheben können. Soweit der Dritte nicht in
                        der Lage ist, uns die gerichtlichen und außergerichtlichen Kosten einer Klage gemäß § 771 ZPO zu
                        erstatten, haftet der Kunde für den uns entstandenen Ausfall.
                    </p>
                    <p>
                        (4) Der Kunde ist berechtigt, die Vorbehaltsware im ordentlichen Geschäftsgang weiter zu
                        verkaufen; er tritt uns jedoch bereits jetzt alle Forderungen in Höhe des Faktura-Endbetrages
                        (einschließlich MwSt.) unserer Forderung ab, die ihm aus der Weiterveräußerung gegen seine
                        Abnehmer oder Dritte erwachsen, und zwar unabhängig davon, ob die Kaufsache ohne oder nach
                        Verarbeitung weiter verkauft worden ist. Wir nehmen die Abtretung an. Zur Einziehung dieser
                        Forderung bleibt der Kunde auch nach der Abtretung ermächtigt. Unsere Befugnis, die Forderung
                        selbst einzuziehen, bleibt hiervon unberührt. Wir verpflichten uns jedoch, die Forderung nicht
                        einzuziehen, solange der Kunde seinen Zahlungsverpflichtungen aus den vereinnahmten Erlösen
                        nachkommt, nicht in Zahlungsverzug gerät und insbesondere kein Antrag auf Eröffnung eines
                        Vergleichs- oder Insolvenzverfahrens gestellt ist oder Zahlungseinstellung vorliegt. Ist aber
                        dies der Fall, so können wir verlangen, dass der Kunde uns die abgetretenen Forderungen und
                        deren Schuldner bekannt gibt, alle zum Einzug erforderlichen Angaben macht, die dazugehörigen
                        Unterlagen aushändigt und den Schuldnern (Dritten) die Abtretung mitteilt.
                    </p>
                    <p>
                        (5) Die Verarbeitung oder Umbildung der Vorbehaltsware durch den Kunden wird stets für uns
                        vorgenommen. Wird die Vorbehaltsware mit anderen, uns nicht gehörenden Gegenständen verarbeitet,
                        so erwerben wir das Miteigentum an der neuen Sache im Verhältnis des Wertes der Vorbehaltsware
                        (Fakturaendbetrag, einschließlich MwSt.) zu den anderen verarbeiteten Gegenständen zur Zeit der
                        Verarbeitung. Für die durch Verarbeitung entstehende Sache gilt im Übrigen das Gleiche wie für
                        die unter Vorbehalt gelieferte Kaufsache.
                    </p>
                    <p>
                        (6) Wird die Vorbehaltsware mit anderen, uns nicht gehörenden Gegenständen untrennbar vermischt,
                        so erwerben wir das Miteigentum an der neuen Sache im Verhältnis des Wertes der Vorbehaltsware
                        (Fakturaendbetrag, einschließlich MwSt.) zu den anderen vermischten Gegenständen zum Zeitpunkt
                        der Vermischung. Erfolgt die Vermischung in der Weise, dass die Sache des Kunden als Hauptsache
                        anzusehen ist, so gilt als vereinbart, dass der Kunde uns anteilmäßig Miteigentum überträgt. Der
                        Kunde verwahrt das so entstandene Alleineigentum oder Miteigentum für uns.
                    </p>
                    <p>
                        (7) Der Kunde tritt uns auch die Forderungen zur Sicherung unserer Forderungen gegen ihn ab, die
                        durch die Verbindung der Vorbehaltsware mit einem Grundstück gegen einen Dritten erwachsen. Wir
                        nehmen die Abtretung an.
                    </p>
                    <p>
                        (8) Wir verpflichten uns, die uns zustehenden Sicherheiten insoweit freizugeben, als der
                        realisierbare Wert unserer Sicherheiten die zu sichernden Forderungen um mehr als 10%
                        übersteigt; die Auswahl der freizugebenden Sicherheiten obliegt uns.
                    </p>
                    <ul>
                        <li><strong>9 Gerichtsstand – Erfüllungsort</strong></li>
                    </ul>
                    <p>
                        (1) Sofern der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder
                        öffentlich-rechtliches Sondervermögen ist, ist unser Geschäftssitz Gerichtsstand; wir sind
                        jedoch berechtigt, den Kunden auch an seinem Wohn- oder Geschäftssitzgericht zu verklagen.
                    </p>
                    <p>
                        (2) Es gilt das Recht der Bundesrepublik Deutschland; die Geltung des UN-Kaufrechts und der
                        Bestimmungen des internationalen Privatrechts ist ausgeschlossen.
                    </p>
                    <p>
                        (3) Sofern sich aus der Auftragsbestätigung nichts anderes ergibt, ist unser Geschäftssitz
                        Erfüllungsort.
                    </p>
                    <p>Ende der AGB.</p>
                    <p><em>Stand: Mai 2024</em></p>
                </div>
            </article>
        </div>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/agb',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: '',
    subTitle: '',
};
</script>

<style scoped>

</style>
